import bhutan from "./campaigns/bhutan";

const REGISTRY = { bhutan };

const getActiveSlug = () => {
  const segs = window.location.pathname.split("/").filter(Boolean);
  if (segs.length && segs[0] !== "admin" && REGISTRY[segs[0]]) return segs[0];
  return "bhutan";
};

export const CAMPAIGN = REGISTRY[getActiveSlug()];

export default CAMPAIGN;
